/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Menu,
  MenuItem,
  useTheme,
  Divider
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'

import { auth } from '../firebase.js'
import { signOut } from 'firebase/auth'
import { useNavigate } from 'react-router-dom'
import LoginModal from './modals/LoginModal.js'
import p4pLogo from '..//assets/images/P4P_logo.png'
import i4slogo from '..//assets/images/I4S_logo_circ.png'
import { PropTypes } from 'prop-types'
import { I18yMenu } from './I18yMenu.js'
import { useTranslation } from 'react-i18next'

const Appbar = ({ displayName }) => {
  const theme = useTheme()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)
  const navigate = useNavigate()
  const isLoggedIn = !!auth.currentUser
  const { t } = useTranslation()

  // Determine user logo
  const userLogo = i4slogo

  function getDisplayStyle (isSomething) {
    return isSomething ? {} : { display: 'none' }
  }

  const isAdmin = !!auth.currentUser?.admin
  const showAdminComponentStyle = getDisplayStyle(isAdmin)

  // opens and closes Menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseMenu = () => {
    setAnchorEl(null)
  }
  // Menu Button Logout
  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        localStorage.removeItem('selectedChatId')
        navigate('/')
        console.log('Sign out successful')
      })
      .catch((error) => {
        console.error('Error signing out: ', error)
      })
  }
  // Login Modal
  const openLoginModal = () => {
    setIsLoginModalOpen(true)
  }

  const closeModals = () => {
    setIsLoginModalOpen(false)
  }

  return (
    <>
      <Box>
        <AppBar
          position="fixed"
          elevation={3}
          sx={{
            height: '84px',
            [theme.breakpoints.down('sm')]: {
              height: '56px'
            }
          }}
        >
          <Toolbar sx={{
            display: 'flex',
            bgcolor: '#fefefe',
            height: '84px',
            [theme.breakpoints.down('sm')]: {
              height: '56px'
            }
          }}>
            <Box
              sx={{
                display: 'flex',
                flex: { xs: 0, md: 1 },
                justifyContent: 'center'
              }}
            >
                          <Box
              sx={{
                display: 'flex',
                flex: { xs: 0, md: 1 },
                justifyContent: 'center'
              }}
            >
              <Box
                sx={{
                  mr: 'auto',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                }}
              >
                <IconButton
                  size="large"
                  edge="start"
                  color="primary"
                  aria-label="menu"
                  sx={{ mr: 2 }}
                  onClick={handleClick}
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleCloseMenu}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button'
                  }}
                >
                  {!isLoggedIn
                    ? (
                    <>
                      <MenuItem onClick={openLoginModal}>{t('sign_in')}</MenuItem>
                    </>
                      )
                    : (
                    <>
                      <MenuItem
                        sx={showAdminComponentStyle}
                        onClick={() => {
                          navigate('/')
                        }}
                      >
                        Lobby
                      </MenuItem>
                      <MenuItem
                        sx={showAdminComponentStyle}
                        onClick={() => {
                          navigate('/list')
                        }}
                      >
                        List Prompts
                      </MenuItem>
                      <MenuItem
                        sx={showAdminComponentStyle}
                        onClick={() => {
                          navigate('/update')
                        }}
                      >
                        Update Prompt
                      </MenuItem>
                      <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
                    </>
                      )}
                </Menu>
              </Box>
            </Box>
            </Box>
            <Box
              sx={{
                display: { xs: 'none', md: 'flex' },
                flex: 1,
                justifyContent: 'center'
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  display: { xs: 'none', md: 'flex' },
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <img
                  src={p4pLogo}
                  alt="Peace Game Logo"
                  style={{
                    width: '220px',
                    height: '100%',
                    objectFit: 'fill',
                    display: 'block'
                  }}
                />
              </Box>
            </Box>
            <Box sx={{ display: 'flex', flex: 1, justifyContent: 'end' }}>

              {isLoggedIn
                ? (
                <Box sx={{ display: 'flex', ml: 'auto', alignItems: 'center' }}>
                  <Typography variant="h6" color="black" sx={{ mr: '5px' }}>
                    {displayName}
                  </Typography>
                  <Divider orientation="vertical" flexItem style={{ marginLeft: '15px', marginRight: '15px' }} />
                  <I18yMenu></I18yMenu>
                </Box>
                  )
                : (
                <I18yMenu></I18yMenu>
                  )}
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
      <LoginModal
        isOpen={isLoginModalOpen}
        handleClose={closeModals}
      ></LoginModal>
    </>
  )
}

Appbar.propTypes = {
  displayName: PropTypes.string
}

export default Appbar
